import React, { Component } from 'react';
import { observer } from 'mobx-react';

import {
  Wrapper,
  Content,
} from './style';

import IntroTitle from '../IntroTitle';
import IntroCloudItem from '../IntroCloudItem';

import AppState from '../../states/AppState';
import IntroCloudState from '../../states/IntroCloudState';

class IntroCloudItems extends Component {
  componentDidMount() {
    this.animate();

    this.lastTwinkle = 0;
    this.minTwinkleDelay = 200;
  }

  animate = (now) => {
    requestAnimationFrame(this.animate);

    if (IntroCloudState.introActive) {
      if (now > this.lastTwinkle + this.minTwinkleDelay) {
        this.lastTwinkle = now;
        const index = Math.floor(Math.random() * IntroCloudState.items.length);
        if (!IntroCloudState.items[index].twinkling) IntroCloudState.twinkleItem(index);
      }
    }
  }

  render() {
    return (
      <Wrapper style={this.props.style}>
        <IntroTitle active={IntroCloudState.introActive} />
        {IntroCloudState.items.map((item, itemIndex) => (
          <IntroCloudItem
            key={itemIndex}
            item={item}
            itemIndex={itemIndex}
            twinkling={item.twinkling}
          />
        ))}
      </Wrapper>
    );
  }
}

export default observer(IntroCloudItems);



// WEBPACK FOOTER //
// ./src/components/IntroCloudItems/index.js